import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import DataVehicleTable from "../../components/Data-vehicle-table/data-vehicle-table";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import "./vehicle-list.css";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { cardIconSx, clientListThemeVars } from "../../theme/globalStyle/globalStyle";
import { canCreateVehicle } from "../../util/vehicle/vehicle-list-utils";

require("firebase/auth");

function VehicleList() {
  const userLogado = useSelector((state) => state.usuarioLogado);
  const user = useSelector((state) => state.user);
  const [clearFiltersKey, setClearFiltersKey] = useState(0);
  const canCreate = canCreateVehicle(user);

  return (
    <>
      {userLogado > 0 ? (
        <NewMiniDrawer
          divOpen={
            <Box
              className="vehicle-list-page"
              sx={pageWrapperSx}
              style={clientListThemeVars}
            >
              <Card sx={heroCardSx}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                  <Box className="vehicle-list-hero">
                    <Stack spacing={1} className="vehicle-list-hero-copy">
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={cardIconSx}>
                          <LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />
                        </Box>
                        <Typography sx={heroTitleSx}>Veículos</Typography>
                      </Box>
                      <Typography sx={heroSubtitleSx}>
                        Consulte, filtre e mantenha o cadastro centralizado de
                        veículos e reboques.
                      </Typography>
                    </Stack>

                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1}
                      sx={{
                        flexShrink: 0,
                        flexWrap: "wrap",
                        gap: 1,
                        width: { xs: "100%", md: "auto" },
                      }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<FilterAltOffOutlinedIcon />}
                        onClick={() => setClearFiltersKey((key) => key + 1)}
                        sx={secondaryActionSx}
                      >
                        Limpar filtros
                      </Button>
                      {canCreate ? (
                        <Button
                          component={Link}
                          to="/vehicle"
                          variant="contained"
                          startIcon={<AddIcon />}
                          sx={primaryActionSx}
                        >
                          Novo veículo
                        </Button>
                      ) : null}
                    </Stack>
                  </Box>
                </CardContent>
              </Card>

              <Card sx={contentCardSx}>
                <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                  <Box className="vehicle-list-table-heading">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={cardIconSx}>
                        <TableRowsOutlinedIcon sx={{ color: "#ffffff" }} />
                      </Box>
                      <Box>
                        <Typography sx={sectionTitleSx}>
                          Lista de veículos
                        </Typography>
                        <Typography sx={sectionSubtitleSx}>
                          Use os filtros das colunas para localizar registros
                          específicos.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box className="vehicle-list-table-shell">
                    <DataVehicleTable clearFiltersKey={clearFiltersKey} />
                  </Box>
                </CardContent>
              </Card>
            </Box>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default VehicleList;

const pageWrapperSx = {
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const heroCardSx = {
  borderRadius: "18px",
  border: "1px solid var(--client-primary-border)",
  boxShadow: "var(--client-shadow-soft)",
};

const contentCardSx = {
  borderRadius: "var(--client-radius-lg)",
  border: "1px solid var(--client-primary-border)",
  boxShadow: "var(--client-shadow-table)",
  background: "var(--client-surface-soft)",
};

const heroTitleSx = {
  color: "var(--client-primary)",
  fontWeight: 700,
  fontSize: "1.25rem",
};

const heroSubtitleSx = {
  color: "rgba(1, 36, 67, 0.74)",
  fontSize: "0.92rem",
  lineHeight: 1.5,
  maxWidth: 760,
};

const sectionTitleSx = {
  color: "var(--client-primary)",
  fontWeight: 700,
  fontSize: "1.05rem",
};

const sectionSubtitleSx = {
  color: "rgba(1, 36, 67, 0.62)",
  fontSize: "0.79rem",
  lineHeight: 1.45,
};

const primaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  backgroundColor: "var(--client-primary)",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "var(--client-primary-hover)",
  },
};

const secondaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  borderColor: "var(--client-primary)",
  color: "var(--client-primary)",
  "&:hover": {
    borderColor: "var(--client-primary-hover)",
    backgroundColor: "rgba(1, 36, 67, 0.04)",
  },
};
